var _namedview, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path, _line13, _line14, _line15, _path2, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAutoBottomTemplate = function SvgAutoBottomTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198.0mm",
    height: "172.2mm",
    viewBox: "-5.0 -5.0 198.0 172.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 45.7,
    y2: 135.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 99,
    y1: 45.7,
    y2: 135.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 154,
    y1: 45.7,
    y2: 135.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    x2: 188,
    y1: 45.7,
    y2: 135.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 10.4,
    y1: 51,
    y2: 46,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 10.4,
    y1: 130,
    y2: 135,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 10.4,
    x2: 10.4,
    y1: 46,
    y2: 135,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 51,
    y2: 130,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1,
    x2: 65,
    y1: 45.2,
    y2: 45.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1,
    x2: 10.1,
    y1: 12,
    y2: 45.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1,
    x2: 16.5,
    y1: 12,
    y2: 12,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 16.5,
    y1: 12,
    y2: 13.5,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 10.1 12 Q 10.1 0 22.4 0"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 11.700000000000003,
    y2: 45.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 58.6,
    x2: 65,
    y1: 11.700000000000003,
    y2: 11.700000000000003,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 58.6,
    x2: 58.6,
    y1: 11.700000000000003,
    y2: 13.200000000000003,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 65.0 11.700000000000003 Q 65.0 -0.29999999999999716 53.0 0"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    x2: 58.6,
    y1: 13.5,
    y2: 13.200000000000003,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 22.4,
    x2: 53,
    y1: 0,
    y2: 0,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    x2: 98.5,
    y1: 35.7,
    y2: 45.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 94.5,
    x2: 98.5,
    y1: 31.700000000000003,
    y2: 35.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 89.5,
    x2: 94.5,
    y1: 22.700000000000003,
    y2: 31.700000000000003,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 67,
    x2: 65,
    y1: 43.7,
    y2: 45.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    x2: 67,
    y1: 22.700000000000003,
    y2: 43.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    x2: 89.5,
    y1: 22.700000000000003,
    y2: 22.700000000000003,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 98.5,
    y1: 45.7,
    y2: 45.7,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 154.5,
    x2: 154.5,
    y1: 35.7,
    y2: 45.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 158.5,
    x2: 154.5,
    y1: 31.700000000000003,
    y2: 35.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 158.5,
    y1: 22.700000000000003,
    y2: 31.700000000000003,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 186,
    x2: 188,
    y1: 43.7,
    y2: 45.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 183,
    x2: 186,
    y1: 22.700000000000003,
    y2: 43.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 163.5,
    x2: 183,
    y1: 22.700000000000003,
    y2: 22.700000000000003,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 154.5,
    x2: 188,
    y1: 45.7,
    y2: 45.7,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 154,
    y1: 45.7,
    y2: 45.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1,
    x2: 188,
    y1: 135.2,
    y2: 135.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1,
    x2: 12.6,
    y1: 135.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 62.5,
    y1: 135.2,
    y2: 137.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    x2: 63.8,
    y1: 137.7,
    y2: 139,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    x2: 63.8,
    y1: 162.2,
    y2: 139,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    x2: 62.5,
    y1: 152.2,
    y2: 137.7,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 37.7,
    x2: 48,
    y1: 152.2,
    y2: 152.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 37.7,
    x2: 37.7,
    y1: 152.2,
    y2: 157.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 32.7,
    x2: 37.7,
    y1: 162.2,
    y2: 157.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 12.6,
    x2: 32.7,
    y1: 162.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    x2: 58,
    y1: 152.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 58,
    x2: 62.5,
    y1: 162.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 101.5,
    y1: 135.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 151.5,
    y1: 135.2,
    y2: 137.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    x2: 152.8,
    y1: 137.7,
    y2: 139,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    x2: 152.8,
    y1: 162.2,
    y2: 139,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 137,
    x2: 151.5,
    y1: 152.2,
    y2: 137.7,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 126.5,
    x2: 137,
    y1: 152.2,
    y2: 152.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 126.5,
    x2: 126.5,
    y1: 152.2,
    y2: 157.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 121.5,
    x2: 126.5,
    y1: 162.2,
    y2: 157.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 121.5,
    y1: 162.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 137,
    x2: 147,
    y1: 152.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 147,
    x2: 151.5,
    y1: 162.2,
    y2: 162.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 82,
    x2: 99,
    y1: 152.2,
    y2: 135.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 67.5,
    y1: 135.2,
    y2: 137.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 67.5,
    x2: 71,
    y1: 137.7,
    y2: 152.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 71,
    x2: 82,
    y1: 152.2,
    y2: 152.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 171,
    x2: 188,
    y1: 152.2,
    y2: 135.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 156.5,
    y1: 135.2,
    y2: 137.7,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 156.5,
    x2: 160,
    y1: 137.7,
    y2: 152.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 171,
    y1: 152.2,
    y2: 152.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "height",
    fill: "#000",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 103.91734,
    y1: 45.424973,
    y2: 135.42538,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 102.91734,
    y1: 45.424973,
    y2: 49.424973,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 104.91734,
    y1: 45.424973,
    y2: 49.424973,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 102.91734,
    y1: 135.42538,
    y2: 131.42538,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 104.91734,
    y1: 135.42538,
    y2: 131.42538,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -92.425049,
    y: 108.91743,
    strokeWidth: 0,
    fontSize: "4px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444447px"
  }, " Height ")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    fill: "#000",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 99,
    y1: 88.050018,
    y2: 88.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 95,
    y1: 88.050018,
    y2: 87.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 95,
    y1: 88.050018,
    y2: 89.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 69,
    y1: 88.050018,
    y2: 87.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 69,
    y1: 88.050018,
    y2: 89.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 82.766663,
    y: 86.050018,
    strokeWidth: 0,
    fontSize: "4px",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444447px"
  }, " Depth ")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "width",
    fill: "#000",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 65,
    y1: 88.108353,
    y2: 88.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 14,
    y1: 88.108353,
    y2: 87.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 14,
    y1: 88.108353,
    y2: 89.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 37.208328,
    y: 86.108353,
    strokeWidth: 0.1,
    fontSize: "4px",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444447px"
  }, " Width ")), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 61,
    y1: 88.108353,
    y2: 87.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 61,
    y1: 88.108353,
    y2: 89.108353,
    strokeWidth: 0.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAutoBottomTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/auto-bottom-template.93b69b9c.svg";
export { ForwardRef as ReactComponent };